export const sequence = {
    sequence_empty_list: 'No hay cuestionarios disponibles para este período de tiempo.',
};
